module.exports = "<wow-specials-group-display></wow-specials-group-display>\r\n<wow-inline-coaching-specials ng-if=\"inlineCoaching.shouldRun('specials')\" wow-inline-coaching></wow-inline-coaching-specials>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/specials/specials-group-center-panel-template.html
 ** module id = 1027
 ** module chunks = 1
 **/